import { Observable, of } from 'rxjs'
import { CanActivate, CanLoad, Route } from '@angular/router'
import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { catchError, map, switchMapTo, take, tap } from 'rxjs/operators'
import * as fromRoot from '@tv3/store/state'
import { IsDataLoaded } from '@tokeet/tv3-platform'
import { selectAISettingsLoaded } from './ai-settings.selectors'
import { LoadAISettings } from './ai-settings.actions'

@Injectable({ providedIn: 'root' })
export class AISettingsGuard implements CanActivate, CanLoad, IsDataLoaded {
  constructor(private store: Store<fromRoot.State>) { }

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(selectAISettingsLoaded),
      tap((isLoaded) => {
        if (!isLoaded) {
          this.store.dispatch(LoadAISettings())
        }
      }),
      map(() => true),
      take(1)
    )
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
